import {
  Building_OfficeOreder_2010_List,
  BuildingOfficeOrderSiteMenuList,
} from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const Building_OfficeOreder_2010 = () => (
  <TableStructure
    title="Office Order/ 2012"
    heading={false}
    list={Building_OfficeOreder_2010_List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2010;
